import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BasketComponent } from './components/basket.component';
import { ChatIconComponent } from './components/chat-icon.component';
import { DiamondComponent } from './components/diamond.component';
import { EyeComponent } from './components/eye.component';
import { InfoIconComponent } from './components/info.component';
import { LinesComponent } from './components/lines.component';
import { LogoutIconComponent } from './components/logout-icon.component';
import { PencilTwoComponent } from './components/pencil-two.component';
import { PencilComponent } from './components/pencil.component';
import { ScreensComponent } from './components/screens.component';
import { SearchComponent } from './components/search.component';
import { SettingsIconComponent } from './components/settings.component';
import { StarComponent } from './components/star.component';
import { LogoComponent } from './components/logo.component';
import { ProfileIconComponent } from './components/profile-icon.component';
import { ChevronRightComponent } from './components/chevron-right.component';
import { WindowsComponent } from './components/windows.component';
import { ListComponent } from './components/list.component';
import { ChromeComponent } from './components/chrome.component';
import { AndroidComponent } from './components/android.component';
import { HappyMacComponent } from './components/happy-mac.component';
import { LogoSmallComponent } from './components/logo-small.component';
import { MidjourneyIconComponent } from './components/midjourney-icon.component';
import { ThirdPartySecondComponent } from './components/third-party-02.component';
import { ThirdPartyFirstComponent } from './components/third-party-01.component';
import { ThirdPartyThirdComponent } from './components/third-party-03.component';
import { MenuLinesIconComponent } from './components/menu-lines-icon.component';
import { ScanIconComponent } from './components/scan-icon.component';
import { ThirdPartyFirstLargeComponent } from './components/third-party-01-large.component';
import { RubizUiVectorComponent } from './components/rubiz-ui-vector.component';
import { DownloadComponent } from './components/download.component';


@NgModule({
  declarations: [
    LogoComponent,
    BasketComponent,
    ChatIconComponent,
    DiamondComponent,
    EyeComponent,
    InfoIconComponent,
    LinesComponent,
    LogoutIconComponent,
    PencilComponent,
    PencilTwoComponent,
    ScreensComponent,
    SearchComponent,
    SettingsIconComponent,
    StarComponent,
    ProfileIconComponent,
    LogoutIconComponent,
    ChevronRightComponent,
    WindowsComponent,
    ListComponent,
    ChromeComponent,
    AndroidComponent,
    HappyMacComponent,
    LogoSmallComponent,
    MidjourneyIconComponent,
    ThirdPartySecondComponent,
    ThirdPartyFirstComponent,
    ThirdPartyThirdComponent,
    MenuLinesIconComponent,
    ScanIconComponent,
    ThirdPartyFirstLargeComponent,
    RubizUiVectorComponent,
    DownloadComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    LogoComponent,
    BasketComponent,
    ChatIconComponent,
    DiamondComponent,
    EyeComponent,
    InfoIconComponent,
    LinesComponent,
    LogoutIconComponent,
    PencilComponent,
    PencilTwoComponent,
    ScreensComponent,
    SearchComponent,
    SettingsIconComponent,
    StarComponent,
    ProfileIconComponent,
    LogoutIconComponent,
    ChevronRightComponent,
    WindowsComponent,
    ListComponent,
    ChromeComponent,
    AndroidComponent,
    HappyMacComponent,
    LogoSmallComponent,
    MidjourneyIconComponent,
    ThirdPartySecondComponent,
    ThirdPartyFirstComponent,
    ThirdPartyThirdComponent,
    MenuLinesIconComponent,
    ScanIconComponent,
    ThirdPartyFirstLargeComponent,
    RubizUiVectorComponent,
    DownloadComponent,
  ]
})
export class IconsModule { }
